import { ZonedDateTimeFactory, ZonedDateTimeFormatter } from '@csp/csp-common-date-util';
import { ZonedDateTime } from '@csp/csp-common-model';
import { RequestCode } from '../codes/RequestCode';
import { ScheduleCode } from '../codes/ScheduleCode';
import { VersionCode } from '../codes/VersionCode';
import { RequestWindow } from '../RequestWindow';
import { GenericScheduleRequestRefV1 } from '../__internal__/GenericScheduleRequestRefV1';
import { GenericRequest } from './GenericRequest';

export type RequestRef = {
  scheduleCode: ScheduleCode;
  versionCode: VersionCode;
  requestCode: RequestCode;
  repeatIndex?: number;
  windowStart?: ZonedDateTime;
  windowEnd?: ZonedDateTime;
};

const toGenericScheduleRequestRefV1 = (requestRef: RequestRef): GenericScheduleRequestRefV1 => ({
  requestCode: requestRef.requestCode,
  scheduleCode: requestRef.scheduleCode,
  versionCode: requestRef.versionCode,
  repeatIndex: requestRef.repeatIndex,
  windowEnd: ZonedDateTimeFormatter.toZonedDateTimeString(requestRef.windowEnd),
  windowStart: ZonedDateTimeFormatter.toZonedDateTimeString(requestRef.windowStart),
});

const fromGenericScheduleRequestRefV1 = (requestRef: GenericScheduleRequestRefV1): RequestRef => ({
  requestCode: requestRef.requestCode,
  scheduleCode: requestRef.scheduleCode,
  versionCode: requestRef.versionCode,
  repeatIndex: requestRef.repeatIndex,
  windowEnd: requestRef.windowEnd ? ZonedDateTimeFactory.fromZonedDateTimeString(requestRef.windowEnd) : undefined,
  windowStart: requestRef.windowStart
    ? ZonedDateTimeFactory.fromZonedDateTimeString(requestRef.windowStart)
    : undefined,
});

const fromRequestWindow = ({
  requestRefCodes: { scheduleCode, versionCode, requestCode },
  repeatIndex,
  windowStart,
  windowEnd,
}: RequestWindow): RequestRef => ({
  scheduleCode,
  versionCode,
  requestCode,
  repeatIndex,
  windowStart,
  windowEnd,
});

const fromGenericRequest = ({ scheduleCode, versionCode, requestCode }: GenericRequest): RequestRef => ({
  scheduleCode,
  versionCode,
  requestCode,
});

export const RequestRef = {
  fromRequestWindow,
  toGenericScheduleRequestRefV1,
  fromGenericRequest,
  fromGenericScheduleRequestRefV1,
};
